import styled from "styled-components";
import {Colors} from "../constants";

export const Background = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: ${Colors.darken};
`;

export const Frame = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.primaryShade};
    width: 810px;
    min-height: 376px;
`;